import * as d3 from "d3"
import * as shared from "./shared"
import { SvgEventHandlers } from "./types"

export const register = (svgElement: SVGSVGElement, handlers?: SvgEventHandlers) => {
  d3.select(svgElement).on("contextmenu", function (event) {
    event.preventDefault()
    const { buttonTarget } = shared.mouseTarget(event)
    handlers?.contextmenu?.(buttonTarget, event)
  })

  return () => d3.select(svgElement).on("contextmenu", null)
}
